import { render, staticRenderFns } from "./V2ProductGallery.vue?vue&type=template&id=287d5b22&scoped=true&"
import script from "./V2ProductGallery.vue?vue&type=script&lang=js&"
export * from "./V2ProductGallery.vue?vue&type=script&lang=js&"
import style0 from "./V2ProductGallery.vue?vue&type=style&index=0&id=287d5b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d5b22",
  null
  
)

export default component.exports